import { css, Global } from '@emotion/react';
import { FeatureFlagProvider } from '@sunrun/sales-experience-shared/react-feature-flags';
import styled from '@emotion/styled/macro';
import { RouterProvider } from 'react-router-dom';
import { tokens } from '@sunrun/experience-ui-components';
import { router } from 'router';
import { useUserProfile } from 'providers/UserProfile';
import { useMixpanelTracker } from 'providers/Mixpanel';

const App = () => {
  useMixpanelTracker();
  const { userProfile } = useUserProfile();
  return (
    <AppContainer>
      <Global
        styles={css`
          @import url('https://fonts.cdnfonts.com/css/roobert');

          html,
          body {
            overscroll-behavior: none;
          }

          body {
            background: ${tokens.BACKGROUND_LIGHT};
            margin: 0px;
            padding: 0px;
            box-sizing: border-box;
            min-height: 100vh;
          }
        `}
      />
      <FeatureFlagProvider identity={userProfile?.contactId}>
        <RouterProvider router={router} />
      </FeatureFlagProvider>
    </AppContainer>
  );
};

const AppContainer = styled.div`
  font-family: 'Roobert', sans-serif;
`;

export { App };
